export const KEY_UPDATE = 'KEY_UPDATE';
export const CLEAR_KEY = "CLEAR_KEY";
export const SINGLE_KEY_UPDATE = "SINGLE_KEY_UPDATE"